var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBgOrnament = function SvgBgOrnament(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 441,
    height: 265,
    viewBox: "0 0 441 265",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-50.4852 81.2567C-46.5243 74.786 -41.0186 70.6302 -34.9129 66.0966C-8.32986 46.3581 21.4272 31.0237 52.9276 21.2675C119.061 0.784979 191.797 0.860166 249.42 42.8184C282.361 66.8037 314.239 109.024 308.47 152.9C305.193 177.817 288.254 195.664 267.58 208.167C245.426 221.564 219.165 229.953 193.332 229.781C173.355 229.648 140.632 221.799 145.762 194.465C148.607 179.304 159.708 167.286 171.403 158.295C195.767 139.567 225.779 132.358 255.796 131.482C307.975 129.96 358.038 149.415 392.026 189.855C404.942 205.22 428.209 246.754 433.84 270.277",
    stroke: "#CFDADB",
    strokeWidth: 14,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBgOrnament);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "bg-ornament.80c88e02d289963835630a625211c207.svg";